
import './Header.scss';
import philipsLogo from './Assets/philips_logo.png'

export default function Header()
{
    return (
        <header className='Header'>

                <div className='Header_lateral_down'>
                    <div className='Header_rainurage'></div>
                    <div className='Header_rainurage'></div>
                    <div className='Header_rainurage'></div>
                    <div className='Header_rainurage'></div>
                    <div className='Header_rainurage'></div>
                </div>




                <div className='Header_center_down'>
                    <div className="Header_center_down_nom">
                        <div className='Header_center_down_nom_philips'>PHILIPS</div>
                        <div className='Header_center_down_nom_logo'><img src={philipsLogo} alt="philips logo" /></div>
                    </div>
                        
                    <div className='Header_center_down_line'></div>

                    <div className='Header_center_down_infos'>
                        <div className='Header_center_down_infos_logo'>VG5000<span className='Header_center_down_infos_logo_micro'>µ</span></div>
                        <div className='Header_center_down_infos_ramrom'>
                            <div className='Header_center_down_infos_ramrom_ram'>24K RAM</div>
                            <div className='Header_center_down_infos_ramrom_rom'>16K ROM</div>
                        </div>
                    </div>
                </div>


                <div className='Header_lateral_down'>
                    <div className='Header_rainurage'></div>
                    <div className='Header_rainurage'></div>
                    <div className='Header_rainurage'></div>
                    <div className='Header_rainurage'></div>
                    <div className='Header_rainurage'></div>
                </div>

        </header>
    )
}